import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MeetingProgress } from '../../../../../api/control.dao';
import { IProgressItem, ProgressBar } from './progress-bar';
import './progress-bar.scss';


interface IProps {
    updateMeetingData: (value: string | MeetingProgress) => void;
    meetingProgress: MeetingProgress;
    disabledSteps?: MeetingProgress[];
}


const MeetingProgressBar = (props: IProps) => {
    const { updateMeetingData, meetingProgress, disabledSteps = [] } = props;

    const statusKey = (statusName: MeetingProgress) => {
        return Object.values(MeetingProgress).indexOf(statusName);
    };

    const activeItem = (meetingProgressType: MeetingProgress) => statusKey(meetingProgress) >= statusKey(meetingProgressType);
    const disabledItem = (meetingProgressType: MeetingProgress) => statusKey(meetingProgress) > statusKey(meetingProgressType);

    const progressBarFields: IProgressItem[] = [
        {
            type: 'Step',
            status: MeetingProgress.READY,
            active: activeItem(MeetingProgress.READY),
            disabled: disabledItem(MeetingProgress.READY),
            label: <FormattedMessage
                id='oe.common.ready'
                defaultMessage='Ready'
                description='Ready label text'
            />
        },
        {
            type: 'Line',
            active: activeItem(MeetingProgress.UNDERWAY),
        },
        {
            type: 'Step',
            status: MeetingProgress.UNDERWAY,
            active: activeItem(MeetingProgress.UNDERWAY),
            disabled: disabledItem(MeetingProgress.UNDERWAY),
            label: <FormattedMessage
                id='oe.common.underway'
                defaultMessage='Underway'
                description='Underway label text'
            />
        },
        {
            type: 'Line',
            active: activeItem(MeetingProgress.ENDED),
        },
        {
            type: 'Step',
            status: MeetingProgress.ENDED,
            active: activeItem(MeetingProgress.ENDED),
            disabled: disabledItem(MeetingProgress.ENDED),
            label: <FormattedMessage
                id='oe.common.ended'
                defaultMessage='Ended'
                description='Ended label text'
            />
        }
    ];

    const handleClick = e => {
        if (e.currentTarget.dataset.value === meetingProgress) {
            updateMeetingData(Object.values(MeetingProgress)[statusKey(meetingProgress) - 1]);
        } else {
            if (disabledSteps.includes(e.currentTarget.dataset.value)) return;
            updateMeetingData(e.currentTarget.dataset.value);
        }
    };

    return (
        <ProgressBar
            progressBarFields={progressBarFields}
            handleClick={handleClick}
        />
    );
};

export { MeetingProgressBar } ;
